import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'lib/jquery'
import { MediaQuery } from 'foundation-sites'
import { PageBase } from 'frontend/common-imports'
import Current from 'frontend/lib/current'
import Constructor from 'frontend/pages/gift-cards/constructor'

export default class NewGiftCardPage extends PageBase {
  static initScroll () {
    if (!this.callback) this.callback = $(window).scroll(() => this.handleScroll())

    this.element = $('.your_design.sliding')
    if (this.element.offset()) this.startingTopOffset = this.element.offset().top
    this.window = $(window)
    this.stopElement = $('.step.select_game')
    this.topBarHeight = $('.top_bar').height()
    if (this.topBarHeight) this.customOffset = this.startingTopOffset * -1 + this.topBarHeight * 2
    this.triggered = false
  }

  static handleScroll () {
    if (!MediaQuery.is('large')) return

    if (!this.element || !this.element.offset() || !this.window) {
      this.initScroll()
      return
    }

    const topOffset = this.element.offset().top
    const bottomOffset = this.stopElement.offset().top
    const topScroll = this.window.scrollTop()

    if (topScroll > topOffset) {
      this.triggered = true
    }

    if (this.triggered && topScroll < bottomOffset && topScroll > this.startingTopOffset) {
      this.element.css({ 'margin-top': topScroll + this.customOffset })
    } else if (topScroll < this.startingTopOffset) {
      this.element.css({ 'margin-top': 0 })
    }
  }

  static render () {
    ReactDOM.render(
      <Constructor
        onComplete={(giftCard) => {
          window.location = `/${Current.cityId}/gift-cards/${giftCard.id}/edit`
        }}
      />,
      document.getElementById('new-gift-card-root')
    )

    this.initScroll()
  }
}

NewGiftCardPage.init()
